<template>
    <div class="field" :class="question.errorMessage ? 'errorBorder' : ''">
        <div class="text title_text" >
            <span>第{{ question.num }}题</span>{{ question.title }}
            <span v-if="question.must === 1" class="req">*</span>           
        </div>  
        <table>
            <tr>
                <td></td>
                <td v-for="(stitle, sindex) in question.options" :key="sindex" class="tdtitle">{{ stitle }}</td>
            </tr>
            <template>
            <tr v-for="(item,dIndex) in question.dimension" :key="item + '_' + dIndex" >
                <td>{{ item }}</td>
                <td v-for="(item,oIndex) in question.options">
                <a class="rate-off" :class="arrSelected[oIndex][dIndex] ? 'rate-on rate-ontxt' : '' " 
                :style="getColor(oIndex,dIndex,question.options.length)"  
                @click="selectCurrent(dIndex, oIndex, question)"
                />
                </td>
            </tr>
            </template>
        </table>
      <div class="errorMessage">{{ question.errorMessage }}</div>
    </div> 
</template>
<script>
export default {
  props: {
    question: Object
  },
  data() {
    return {
        arrSelected:Array.from({ length: this.question.options.length }, () => Array(this.question.dimension.length).fill(false)),
        arrAns:Array(this.question.options.length).fill(-1)                              
    };
  },
  created() {
    const question = this.question;
    if (question.answer !== undefined && question.answer !== null) {
      this.setSelectedAnswer(question.answer);
    }
  },
  methods: {
    // 设置选中的答案
    setSelectedAnswer(answer) {
      const array = answer.split(/,|</);
      const arrSelected = this.arrSelected;
      for (let i = 0; i < array.length; i++) {
        this.arrAns[i] = array[i]
        arrSelected[i][array[i]-1] = true;
      }
    },
    
    selectCurrent: function(index, sindex, question) {
      let iIndex = sindex;
      let value = Array(question.dimension.length).fill(false)
      value[index] = true;
      if (sindex + 1) {
        this.$set(this.arrSelected, iIndex, value);
      } else {
        this.$set(this.arrSelected, 0, value);
      }
      this.arrAns[iIndex] = index + 1;
      let arrAns = this.arrAns;
      let ans = "";
      for (let i = 0; i < arrAns.length / question.options.length; i++) {
        for (let j = 0; j < question.options.length; j++) {
          ans += arrAns[question.options.length * i + j] + "<"
        }
        ans = ans.substring(0, ans.lastIndexOf("<"));
        ans += ','
      }
      ans = ans.substring(0, ans.lastIndexOf(","));
      let strNum = this.countOccurrencesWithRegex(ans, "-1");
      question.answer = ans;
      if (strNum == 0) {
        question.errorMessage = "";
        question.finish = 1;
      } 
      this.$emit("listenToChildEvent", question.num, ans, question);
    },
    countOccurrencesWithRegex: function(str, substr) {
      const regex = new RegExp(substr, "g");
      const matches = str.match(regex);
      return matches ? matches.length : 0;
    },
    getColor(yIndex,xIndex,pLength) {
      let xTrue = false            
      for (let i = 0; i < pLength; i++) {
        if(i !== yIndex && !xTrue){
          xTrue = this.arrSelected[i][xIndex] 
        }
      }
      let dynamicStyles = {
        'pointer-events': 'none',
        'cursor': 'not-allowed',
        'background':'#ccc'
      }
      return xTrue ? dynamicStyles : {};
    }
  }
};
</script>
<style lang="stylus" scoped>
.field{
margin-bottom :20px
}

table {
width: 94%;
background: #fff;
margin: auto;
padding: 0.1rem;
border :1px solid #bcb5b5;
padding-left :10px
}

table th {
padding: 0.16rem 0;
width: 9%;
text-align: center;
font-weight: normal;
}

table th:first-child, table th:last-child {
width: 13%;
}

table tr{
display :flex;
justify-content :space-evenly
margin-left :20px
}
table tr .tdtitle {
text-align: left;
border: none;
padding: 10px 10px 6px 0px;
}

table td {
padding: 5px 6px 10px 10px;
text-align: left;
line-height :18px;
flex :1
}


.rate-off {
width: 21px;
height: 21px;
text-decoration: none;
border-radius: 30px;
color: #333;
border: 1px solid #cacece;
cursor: default;
display: inline-block;
background: #fafafa;
line-height: 19px;
text-align: center;
display: inline-block;
padding-top :10px
}

.rate-text{
display inline-block;
margin-left 10px;
}
.rate-on {
background-color: #53a4f4 !important;
border: 1px solid #53a4f4;
position: relative;
color: #fff;
}

a.rate-ontxt:after {
question: ' ';
width: 10px;
height: 10px;
border-radius: 50%;
position: absolute;
top: 5px;
background: #fff;
text-shadow: 0px;
// left: 5px;
font-size: 32px;
}

.req {
color: red
}

.title_text {
font-weight: bold;
text-align :left;
margin-bottom :20px
}
.scale-h2{
font-size :16px
margin-bottom :10px;
margin-top :20px;
padding-top :10px;
font-weight :bold
}

.scale-div{
  border:1px solid #918e8e;
  margin-bottom:20px;
  font-size:12px;
}

.questNum{
  color: #000;
  font-size :15px
}

.field_title{
    font-size :16px;
    margin-left :10px;
    margin-bottom :10px;
    margin-top:10px;
    color:#000
}
</style>
